import { render } from "./MoveHistory.vue?vue&type=template&id=7f118fe0&scoped=true"
import script from "./MoveHistory.vue?vue&type=script&lang=js"
export * from "./MoveHistory.vue?vue&type=script&lang=js"

import "./MoveHistory.vue?vue&type=style&index=0&id=7f118fe0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f118fe0"]])

export default __exports__